<template>
    <b-card no-body class="card-transparent-background my-0 p-0">
        <b-card-body class="p-0">
            <div class="mx-0">
                <!-- {{ type }} -->
                <b-row>
                    <b-col sm="6">
                        <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'First Name*' : 'First Name'"
                            label-for="first_name" :first_name="first_name" label-class="form-label-garden-help"
                            :label-cols-xl="type == 'view' ? 3 : 12" :content-cols-xl="type == 'view' ? 9 : 12"
                            :label-cols-lg="type == 'view' ? 4 : 12" :content-cols-lg="type == 'view' ? 8 : 12"
                            :label-cols-md="type == 'view' ? 5 : 12" :content-cols-md="type == 'view' ? 7 : 12"
                            label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_first_name">
                                Please enter first name
                            </p>
                            <b-form-input v-if="type == 'register' || type == 'add' || type == 'edit'" id="first_name"
                                class="form-control-garden-help" v-model="_first_name" placeholder="Enter your first name"
                                required></b-form-input>
                            <span v-if="type == 'view'" class="form-control form-control-garden-help">
                                {{ _first_name }}
                            </span>
                        </b-form-group>
                    </b-col>

                    <b-col sm="6">
                        <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Last Name*' : 'Last Name'"
                            label-for="last_name" :last_name="last_name" label-class="form-label-garden-help"
                            :label-cols-xl="type == 'view' ? 3 : 12" :content-cols-xl="type == 'view' ? 9 : 12"
                            :label-cols-lg="type == 'view' ? 4 : 12" :content-cols-lg="type == 'view' ? 8 : 12"
                            :label-cols-md="type == 'view' ? 5 : 12" :content-cols-md="type == 'view' ? 7 : 12"
                            label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_last_name">
                                Please enter last name
                            </p>
                            <b-form-input v-if="type == 'register' || type == 'add' || type == 'edit'" id="last_name"
                                class="form-control-garden-help" v-model="_last_name" placeholder="Enter your last name"
                                required></b-form-input>
                            <span v-if="type == 'view'" class="form-control form-control-garden-help">
                                {{ _last_name }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group class="form-group-garden-help"
                            :label="type != 'view' ? 'Email Address*' : 'Email Address'" label-for="email"
                            label-class="form-label-garden-help" :label-cols-xl="type == 'view' ? 3 : 12"
                            :content-cols-xl="type == 'view' ? 9 : 12" :label-cols-lg="type == 'view' ? 4 : 12"
                            :content-cols-lg="type == 'view' ? 8 : 12" :label-cols-md="type == 'view' ? 5 : 12"
                            :content-cols-md="type == 'view' ? 7 : 12" label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_email">
                                Please enter email address
                            </p>
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_correct_email">
                                The email is invalid
                            </p>
                            <b-form-input v-if="type == 'register' || type == 'add' " id="email"
                                type="email" class="form-control-garden-help w-100" v-model="_email"
                                placeholder="Enter your email" required @keydown.space.prevent></b-form-input>
                            <span v-if="type == 'view' || type == 'edit'" class="form-control form-control-garden-help">
                                {{ _email }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group class="mobile-number-input-group-garden-help "
                            :class="{ 'form-group-garden-help': type == 'view' }"
                            :label="type != 'view' ? 'Phone Number*' : 'Phone Number'" label-for="phone_number"
                            :phone_number="phone_number" label-class="form-label-garden-help"
                            :label-cols-xl="type == 'view' ? 3 : 12" :content-cols-xl="type == 'view' ? 9 : 12"
                            :label-cols-lg="type == 'view' ? 4 : 12" :content-cols-lg="type == 'view' ? 8 : 12"
                            :label-cols-md="type == 'view' ? 5 : 12" :content-cols-md="type == 'view' ? 7 : 12"
                            label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_phone_number">
                                Please enter phone number
                            </p>
                            <vue-tel-input v-if="(type == 'register' || type == 'add' || type == 'edit')&&country_code!=''"
                                class="form-control form-control-garden-help" id="phone_number" v-model="_phone_number" :value="_phone_number"
                                :defaultCountry="'' + country_code" :country="''+country_code" :enabledCountryCode="false" 
                               :key="country_code" required></vue-tel-input>
                            <span v-if="type == 'view'" class="form-control form-control-garden-help">
                                {{ _phone_number }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>

                    <b-col sm="12">
                        <b-form-group class="form-group-garden-help" label="Address" label-for="address"
                            label-class="form-label-garden-help" :label-cols-xl="type == 'view' ? 3 : 12"
                            :content-cols-xl="type == 'view' ? 9 : 12" :label-cols-lg="type == 'view' ? 4 : 12"
                            :content-cols-lg="type == 'view' ? 8 : 12" :label-cols-md="type == 'view' ? 5 : 12"
                            :content-cols-md="type == 'view' ? 7 : 12" label-cols="12" content-cols="12">
                            <p v-if="invalid_address" class="error_validation_message_p_gardenhelp">
                                Please enter address
                            </p>
                            <p v-if="invalid_address_longitude || invalid_address_latitude"
                                class="error_validation_message_p_gardenhelp">
                                Please select correct address
                            </p>
                            <gmap-autocomplete v-if="type == 'register' || type == 'add' || type == 'edit'"
                                @place_changed="updatePlace" class="form-control form-control-garden-help w-100 h-auto"
                                :country="map_countries" id="address_input" ref="addressInputRef" name="address"
                                placeholder="Address" :componentRestrictions="{ country: country_code }">
                            </gmap-autocomplete>
                            <span v-if="type == 'view' || type == 'view_add_job'"
                                class="form-control form-control-garden-help">
                                {{ _address }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group class="form-group-garden-help"
                            :label="type != 'view' ? 'Experience Level*' : 'Experience Level'" label-for="experience_level"
                            :experience_level="experience_level" label-class="form-label-garden-help"
                            :label-cols-xl="type == 'view' ? 3 : 12" :content-cols-xl="type == 'view' ? 9 : 12"
                            :label-cols-lg="type == 'view' ? 4 : 12" :content-cols-lg="type == 'view' ? 8 : 12"
                            :label-cols-md="type == 'view' ? 5 : 12" :content-cols-md="type == 'view' ? 7 : 12"
                            label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_experience_level">
                                Please select experience level
                            </p>
                            <v-select v-if="type == 'register' || type == 'add' || type == 'edit'"
                                :options="experience_levels_list" v-model="_experience_level" name="experience_level"
                                title="experience_level" placeholder="Select experience level" label="name"
                                :reduce="(item) => item.id" :clearable="false" required>
                            </v-select>
                            <span v-if="type == 'view'" class="form-control form-control-garden-help">
                                {{ _experience_level }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group class="form-group-garden-help"
                            :label="type != 'view' ? 'Choose Service*' : 'Services/Skills'" label-for="service"
                            :service="service" label-class="form-label-garden-help" :label-cols-xl="type == 'view' ? 3 : 12"
                            :content-cols-xl="type == 'view' ? 9 : 12" :label-cols-lg="type == 'view' ? 4 : 12"
                            :content-cols-lg="type == 'view' ? 8 : 12" :label-cols-md="type == 'view' ? 5 : 12"
                            :content-cols-md="type == 'view' ? 7 : 12" label-cols="12" content-cols="12">
                            <p class="error_validation_message_p_gardenhelp" v-if="invalid_service">
                                Please select service
                            </p>
                            <v-select v-if="type == 'register' || type == 'add' || type == 'edit'" :options="servies_list"
                                v-model="_service" name="service" title="service" placeholder="Choose service" label="name"
                                :reduce="(item) => item.id" :clearable="false" :multiple="true" required
                                :closeOnSelect="false">
                            </v-select>
                            <span v-if="type == 'view'" class="form-control form-control-garden-help">
                                {{ getServicesNamesFromObject(_service, false) }}
                            </span>
                        </b-form-group>
                    </b-col>
                </b-row>

            </div>
        </b-card-body>
    </b-card>
</template>
  
<script>
import { listServicesRequest, listExperienceLevels, getServicesNamesFromObject } from "@/utils/helper-functions-garden-help.js";
import $ from "jquery";

export default {
    name: "StaffDataComponent",
    components: {},
    props: [
        "type",
        "first_name",
        "invalid_first_name",
        "last_name",
        "invalid_last_name",
        "email",
        "invalid_email",
        "invalid_correct_email",
        "phone_number",
        "invalid_phone_number",
        "experience_level",
        "invalid_experience_level",
        "service",
        "invalid_service",
        "address",
        "longitude",
        "latitude",
        "invalid_address",
        "invalid_address_longitude",
        "invalid_address_latitude",
        "country_code",
        "country",
        "county",
        "city",
    ],
    data() {
        return {
            experience_levels_list: [],
            servies_list: [],


            map_countries: ["ie", "gb", "eg"],
            map_types: [],
            componentRestrictions: {},


        };
    },
    beforeMount() {
        let map_countries_str = process.env.MAP_COUNTRIES;
        this.map_countries = map_countries_str.split(",");
        console.log(this.map_countries);
        this.componentRestrictions.country = map_countries_str.split(",");
        console.log(this.componentRestrictions);
        // console.log(this.country_code)
        //
    },
    async mounted() {
        this.servies_list = await this.listServicesRequest(null);
        this.experience_levels_list = listExperienceLevels();

        console.log(this.servies_list)
        console.log(this.experience_levels_list)

        console.log(this.$refs.addressInputRef)

        if(this._address){
            $("#address_input").val(this.address);
        }else{            
            $("#address_input").val('');
        }

    },
    computed: {
        _first_name: {
            get() {
                return this.first_name;
            },
            set(value) {
                this.$emit("update:first_name", value);
            },
        },
        _last_name: {
            get() {
                return this.last_name;
            },
            set(value) {
                this.$emit("update:last_name", value);
            },
        },
        _email: {
            get() {
                return this.email;
            },
            set(value) {
                this.$emit("update:email", value);
            },
        },
        _phone_number: {
            get() {
                return this.phone_number;
            },
            set(value) {
                this.$emit("update:phone_number", value);
            },
        },

        _experience_level: {
            get() {
                return this.experience_level;
            },
            set(value) {
                this.$emit("update:experience_level", value);
            },
        },
        _service: {
            get() {
                return this.service;
            },
            set(value) {
                this.$emit("update:service", value);
            },
        },

        _address: {
            get() {
                return this.address;
            },
            set(value) {
                this.$emit("update:address", value);
            },
        },
        _longitude: {
            get() {
                return this.longitude;
            },
            set(value) {
                this.$emit("update:longitude", value);
            },
        },
        _latitude: {
            get() {
                return this.latitude;
            },
            set(value) {
                this.$emit("update:latitude", value);
            },
        },

        _country: {
            get() {
                return this.country;
            },
            set(value) {
                this.$emit("update:country", value);
            },
        },
        _county: {
            get() {
                return this.county;
            },
            set(value) {
                this.$emit("update:county", value);
            },
        },
        _city: {
            get() {
                return this.city;
            },
            set(value) {
                this.$emit("update:city", value);
            },
        },
    },
    methods: {
        listServicesRequest, listExperienceLevels, getServicesNamesFromObject,

        updatePlace(place) {
            console.log(place);
            $("#address_input").val(place.formatted_address);
            //   this.$emit("update:dropoff_eircode", place.name);
            this.$emit("update:address", place.formatted_address);
            console.log(place.geometry.location.lat());
            console.log(place.geometry.location.lng());
            // this.dropoff_latitude = place.latitude;
            this.$emit("update:latitude", place.geometry.location.lat());
            // this.dropoff_longitude = place.longitude;
            this.$emit("update:longitude", place.geometry.location.lng());

            for (let i = 0; i < place.address_components.length; i++) {
                let item = place.address_components[i]
                console.log(item)
                if (item.types[0] == 'country') {
                    console.log("country", item.long_name)
                    this._country = item.long_name
                }
                else if (item.types[0] == 'administrative_area_level_1') {
                    console.log("county", item.long_name)
                    this._county = item.long_name
                }
                else if (item.types[0] == 'locality' ||
                    item.types[0] == 'administrative_area_level_2') {
                    console.log("city", item.long_name)
                    this._city = item.long_name
                }
            }

            console.log(this._country, this._county, this._city)


            this.componentRestrictions.country = [this.country_code]
        },
    },
};
</script>
  
<style scoped></style>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/StaffDataComponent.vue